import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isCategoryDropdown, setIsCategoryDropdown] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
    setIsCategoryDropdown(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-vidicon-line text-background-50 text-lg"></i>
            </div>
            <span
              className={`font-heading text-xl font-semibold ${
                isScrolled ? 'text-foreground-900' : 'text-background-50'
              }`}
            >
              黄瓜视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : isScrolled
                  ? 'text-foreground-700'
                  : 'text-background-50/90'
              }`}
            >
              首页
            </Link>

            <div
              className="relative"
              onMouseEnter={() => setIsCategoryDropdown(true)}
              onMouseLeave={() => setIsCategoryDropdown(false)}
            >
              <button
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-500'
                    : isScrolled
                    ? 'text-foreground-700'
                    : 'text-background-50/90'
                }`}
              >
                分类浏览
                <i className="ri-arrow-down-s-line text-sm"></i>
              </button>
              {isCategoryDropdown && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3">
                  <div className="bg-background-50 rounded-xl border border-background-200/70 py-3 px-2 shadow-lg min-w-[480px]">
                    <div className="grid grid-cols-4 gap-1">
                      {categories.map((cat) => (
                        <Link
                          key={cat.slug}
                          to={`/category/${cat.slug}`}
                          className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-background-100 transition-colors group whitespace-nowrap"
                        >
                          <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                            <i className={`${cat.icon} text-primary-600 text-sm`}></i>
                          </div>
                          <span className="text-sm text-foreground-700 font-medium">{cat.name}</span>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : isScrolled
                  ? 'text-foreground-700'
                  : 'text-background-50/90'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                isScrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30'
              }`}
            >
              下载APP
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
          >
            <i
              className={`text-xl ${
                isScrolled ? 'text-foreground-900' : 'text-background-50'
              } ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              className="block px-3 py-3 rounded-lg text-foreground-700 hover:bg-background-100 text-sm font-medium"
            >
              首页
            </Link>
            <div className="px-3 py-2 text-xs text-foreground-500 font-medium">分类浏览</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-3 py-3 rounded-lg text-foreground-700 hover:bg-background-100 text-sm"
              >
                <div className="w-7 h-7 rounded-md bg-primary-100 flex items-center justify-center">
                  <i className={`${cat.icon} text-primary-600 text-xs`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-3 py-3 rounded-lg text-foreground-700 hover:bg-background-100 text-sm font-medium"
            >
              关于我们
            </Link>
            <Link
              to="/about"
              className="block mx-3 mt-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center"
            >
              下载APP
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}